import { EmptyState } from "@/components/molecules";

export const RatingsEmptyState = () => <EmptyState title="Driver Ratings" description="There are currently no driver ratings available" />;
